import { getUserSession } from 'utils/userUtils';
import ApiWrapper from './ApiWrapper';

class AssistentAPI extends ApiWrapper{
  constructor() {
    super(process.env.REACT_APP_API_URL);
  }

  question(question: string, history: any[] = []) {
    return this.fetch({
      endpoint: 'assistant/ask',
      method: 'POST',
      body: {
        ticket: "null",
        sistema: "Siga Emissor",
        modulo: "SGE",
        origem: "Siga Emissor",
        usuario: getUserSession().nome,
        cliente: getUserSession().RazaoSocial,
        pergunta: question,
        historico: history
      },
    });
  }

  feedBack({ idconsulta, pergunta, resposta, comentario, avaliacao }: { idconsulta: string, pergunta: string, resposta: string, comentario: string, avaliacao: boolean }) {
    return this.fetch({
      endpoint: 'assistant/feedbacks',
      method: 'POST',
      body: {
        idconsulta: idconsulta,
        sistema: "Siga Emissor",
        modulo: "SGE",
        origem: "Siga Emissor",
        usuario: getUserSession().nome,
        cliente: getUserSession().RazaoSocial,
        pergunta: pergunta,
        resposta: resposta,
        comentario: comentario,
        avaliacao: avaliacao
      },
    });
  }

  questions({ ini, fin, page, size }: { ini: string, fin: string, page?: number, size?: number }){
    return this.fetch({
      endpoint: 'assistant/questions',
      method: 'GET',
      query: {
        ini,
        fin,
        page,
        size
      }
    });
  };

  getQuestionByGuid({ guid }: { guid: string }){
    return this.fetch({
      endpoint: 'assistant/question/' + guid,
      method: 'GET'
    });
  };
};

const assistentAPI = new AssistentAPI();
export default assistentAPI;